import type React from 'react';

import { SetPageStateValue } from '#src/shared/pageState';

import { usePageState } from './hooks/usePageState';

export const PageState: React.FC<EmptyProps> = () => {
	const {
		data: { states },
	} = usePageState();

	return (
		<>
			{states.map(({ name, value }) => (
				<SetPageStateValue key={name} name={name} value={value} />
			))}
		</>
	);
};
